import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import classNames from 'classnames';
import styles from './button.module.scss';

const buttonClasses = props => {
  const {className, size, variant, fullWidth} = props;
  return classNames(
    styles.Button,
    styles[`Button--${variant}`],
    styles[`Button--${size}`],
    {[styles['Button--fullWidth']]: fullWidth},
    className
  );
};

const Button = props => {
  const {href, children, onClick} = props;

  if (onClick) {
    return (
      <button className={buttonClasses(props)} onClick={onClick} type="button">
        {children}
      </button>
    );
  }

  if (/http/.test(href)) {
    return (
      <a className={buttonClasses(props)} href={href}>
        {children}
      </a>
    );
  }

  return (
    <Link className={buttonClasses(props)} to={href}>
      {children}
    </Link>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  fullWidth: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium']), // eslint-disable-line react/no-unused-prop-types
  // eslint-disable-next-line react/no-unused-prop-types
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'inverse',
    'inverseOutline',
  ]),
};

Button.defaultProps = {
  className: '',
  fullWidth: false,
  href: '#',
  size: 'medium',
  variant: 'primary',
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js